// project-imports
import {
  GET_CATEGORIES_BEGIN,
  GET_CATEGORIES_FAILURE,
  GET_CATEGORIES_SUCCESS,
} from "../constants/actions";

// State variable initialization
export const initialState = {
  categoriesLoading: false,
  categoriesError: null,
  categories: [],
};

const categoriesReducer = (state = initialState, action) => {

  if (action.type === GET_CATEGORIES_BEGIN) {
    // Set loading state
    return {
      ...state,
      categoriesLoading: action.payload,
      categoriesError: null,
    };
  }

  if (action.type === GET_CATEGORIES_SUCCESS) {

    // Update state with all categories
    return {
      ...state,
      categoriesLoading: false,
      categories: action.payload,
      categoriesError: false,
    };
  }

  if (action.type === GET_CATEGORIES_FAILURE) {
    // Set error state
    return {
      ...state,
      categories: [],
      categoriesLoading: false,
      categoriesError: action.payload,
    };
  }

  return state;
};

export default categoriesReducer;
